"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixHatBraces = fixHatBraces;
const tex_syntax_1 = require("./tex-syntax");
function fixHatBraces(tex) {
    return tex
        .replace(/\\hat\s*\\bold\s+([a-z])/g, "\\hat{\\bold $1}")
        .replace(new RegExp(`(\\\\hat)(\\\\text${(0, tex_syntax_1.block)(0)})`), "$1{$2}");
}
